import { memo } from 'react';
import NextImage from 'next/image';
import { yupResolver } from '@hookform/resolvers/yup';
import { SubmitHandler, useForm } from 'react-hook-form';

import { Button } from 'components/common/button';
import Text from 'components/common/text';
import { useHandleWithGoogle } from 'lib/mutation/google';
import { PageLoader } from 'components/common/loader';
import Select from 'components/common/select';
import { Fields } from 'types/fields';
import { signUpWithGoogleSchema } from 'utils/validations';
import { SignUpWithGoogleFormWrapper } from './styles';
import Error from 'components/common/error';
import TextFieldPhone from 'components/common/text-field-phone';

function SignUpWithGoogle() {
  const {
    handleSubmit,
    formState: { errors },
    control,
    watch,
  } = useForm<Fields>({
    mode: 'onChange',
    resolver: yupResolver(signUpWithGoogleSchema),
  });

  const {
    error: errGoogle,
    isError: isErrGoogle,
    loading,
    handleGoogle,
  } = useHandleWithGoogle({
    usagePurpose: watch('signUpGoogleUsagePurpose'),
    phone: watch('signUpGooglePhone'),
  });

  const onSubmit: SubmitHandler<Fields> = async () => {
    handleGoogle();
  };

  return (
    <SignUpWithGoogleFormWrapper onSubmit={handleSubmit(onSubmit)}>
      {isErrGoogle && <Error data={errGoogle?.response?.data.errors} />}
      <Select
        control={control}
        name="signUpGoogleUsagePurpose"
        label="Choose how would you like to use Richr"
        error={errors.signUpGoogleUsagePurpose}
      />

      <TextFieldPhone
        control={control}
        name="signUpGooglePhone"
        label="Phone"
        error={errors.signUpGooglePhone}
      />
      <Text type="mode2" className="and" fw="light">
        and
      </Text>

      <Button type="submit" mode="google" className="sign-in-form-google">
        <NextImage src="/static/icons/google.svg" width={24} height={24} />

        <Text>Continue with Google</Text>
      </Button>
      {loading && <PageLoader />}
    </SignUpWithGoogleFormWrapper>
  );
}

export default memo(SignUpWithGoogle);
